import { twMerge } from "tailwind-merge";

export const QuantityIndicator = ({
  quantity,
  className,
}: {
  quantity: number;
  className?: string;
}) => {
  return (
    <span
      className={twMerge(
        "flex h-[22px] w-[22px] items-center justify-center rounded-full bg-red-500 text-white",
        className,
      )}
    >
      {quantity}
    </span>
  );
};
